import { getDaysDifference, getDateAt12AM, dateAddDays, getDate, formatDate } from '/source/js/utils/dateUtil';

// if UTC date is <= 10AM (cutoff), server will send current UTC date, else UTC date + 1
// on client side, we will check using user's locale.
// If local date + 1 <= server startDate, we will use server date
// If local date + 1 > server startDate, we will use local date (prevents selecting current date after 12AM local)
export function getNextSubscriptionStartDate(startDate, dateFormat) {
    // create date object based on a start date that is format specific to market
    const serverStartDate = getDate(startDate, dateFormat.toLowerCase());

    // get next day locally
    let localStartDate = getDateAt12AM();
    localStartDate = dateAddDays(localStartDate, 1);

    // get local date diff vs server date
    const daysDiff = getDaysDifference(serverStartDate, localStartDate);

    // return date to use but format it based on market
    if(daysDiff <= 0) {
        return formatDate(serverStartDate, dateFormat);
    } else {
        return formatDate(localStartDate, dateFormat);
    }
}
